<template>
  <div>
    <el-breadcrumb separator-icon="ArrowRight" style="margin: 16px">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>宿舍管理</el-breadcrumb-item>
      <el-breadcrumb-item>房间信息</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card style="margin: 15px; min-height: calc(100vh - 111px)">
      <div>
        <!--    功能区-->
        <div style="margin: 10px 0">
          <!--    搜索区-->
          <div style="margin: 10px 0">
            <el-input v-model="search" clearable placeholder="请输入房间号" prefix-icon="Search" style="width: 15%" @keyup.enter="handleSearch" />
            <el-button icon="Search" style="margin-left: 5px" type="primary" @click="handleSearch"></el-button>
            <el-button icon="refresh-left" style="margin-left: 10px" type="default" @click="reset"></el-button>
            <div style="float: right;display: flex;align-items: center;">
              <el-switch v-model="isCheckedIn" @change="switchHandle" :inactive-value="1" :active-value="0" size="large"
                active-text="空宿舍" inactive-text="全部" style="margin-right: 20px;" />
              <el-select v-model="currentCapacityFilter" placeholder="入住人数" clearable style="width: 120px; margin-right: 20px;" @change="handleCapacityFilter">
                <el-option label="0人" :value="0" />
                <el-option label="1人" :value="1" />
                <el-option label="2人" :value="2" />
                <el-option label="3人" :value="3" />
                <el-option label="4人" :value="4" />
              </el-select>
              <el-tooltip content="导入房间" placement="top">
                <el-button icon="Upload" style="margin-right: 10px" type="warning" @click="handleImportRoom"></el-button>
              </el-tooltip>
              <el-tooltip content="添加" placement="top">
                <el-button icon="plus" style="width: 50px" type="primary" @click="add"></el-button>
              </el-tooltip>
              <el-button v-show="multipleSelection.length > 0"  type="danger" @click="checkOutRoom">批量退房</el-button>
            </div>
          </div>
        </div>
        <!--    表格-->
        <el-table ref="multipleTable" v-loading="loading" :data="tableData" border max-height="705" style="width: 100%"
          @selection-change="handleSelectionChange">
          <!-- <el-table-column label="#" type="index" /> -->
          <el-table-column type="selection" width="55">
          </el-table-column>
          <!-- 床位展开-->
          <el-table-column type="expand">
            <template #default="props">
              <el-form inline label-position="left">
                <el-form-item v-if="props.row.maxCapacity > 0 || props.row.firstBed != null" label="一号床位" class="item">
                  <template #default="scope">
                    <el-tag v-if="props.row.firstBed != null" disable-transitions type="primary">{{ props.row.firstBedName
                    }}
                    </el-tag>
                    <div class="el-form--inline-icon">
                      <el-icon v-if="props.row.firstBed == null" @click="plusIcon(1, props.row)">
                        <plus />
                      </el-icon>
                      <div v-if="props.row.firstBed != null" class="el-form--inline-icon">
                        <el-icon @click="detailIcon(1, props.row)">
                          <more-filled />
                        </el-icon>
                        <el-icon @click="editIcon(1, props.row)">
                          <edit />
                        </el-icon>
                        <el-popconfirm title="确认删除？" @confirm="deleteStuBed(1, props.row)">
                          <template #reference>
                            <el-icon>
                              <delete />
                            </el-icon>
                          </template>
                        </el-popconfirm>
                      </div>
                    </div>
                  </template>
                </el-form-item>
                <el-form-item v-if="props.row.maxCapacity > 1 || props.row.secondBed != null" label="二号床位" class="item">
                  <template #default="scope">
                    <el-tag v-if="props.row.secondBed != null" disable-transitions type="primary">{{ props.row.secondBedName
                    }}
                    </el-tag>
                    <div class="el-form--inline-icon">
                      <el-icon v-if="props.row.secondBed == null" @click="plusIcon(2, props.row)">
                        <plus />
                      </el-icon>
                      <div v-if="props.row.secondBed != null" class="el-form--inline-icon">
                        <el-icon @click="detailIcon(2, props.row)">
                          <more-filled />
                        </el-icon>
                        <el-icon @click="editIcon(2, props.row)">
                          <edit />
                        </el-icon>
                        <el-popconfirm title="确认删除？" @confirm="deleteStuBed(2, props.row)">
                          <template #reference>
                            <el-icon>
                              <delete />
                            </el-icon>
                          </template>
                        </el-popconfirm>
                      </div>
                    </div>
                  </template>
                </el-form-item>
                <el-form-item v-if="props.row.maxCapacity > 2 || props.row.thirdBed != null" label="三号床位" class="item">
                  <template #default="scope">
                    <el-tag v-if="props.row.thirdBed != null" disable-transitions type="primary">{{ props.row.thirdBedName
                    }}
                    </el-tag>
                    <div class="el-form--inline-icon">
                      <el-icon v-if="props.row.thirdBed == null" @click="plusIcon(3, props.row)">
                        <plus />
                      </el-icon>
                      <div v-if="props.row.thirdBed != null" class="el-form--inline-icon">
                        <el-icon @click="detailIcon(3, props.row)">
                          <more-filled />
                        </el-icon>
                        <el-icon @click="editIcon(3, props.row)">
                          <edit />
                        </el-icon>
                        <el-popconfirm title="确认删除？" @confirm="deleteStuBed(3, props.row)">
                          <template #reference>
                            <el-icon>
                              <delete />
                            </el-icon>
                          </template>
                        </el-popconfirm>
                      </div>
                    </div>
                  </template>
                </el-form-item>
                <el-form-item v-if="props.row.maxCapacity > 3 || props.row.fourthBed != null" label="四号床位" class="item">
                  <template #default="scope">
                    <el-tag v-if="props.row.fourthBed != null" disable-transitions type="primary">{{ props.row.fourthBedName
                    }}
                    </el-tag>
                    <div class="el-form--inline-icon">
                      <el-icon v-if="props.row.fourthBed == null" @click="plusIcon(4, props.row)">
                        <plus />
                      </el-icon>
                      <div v-if="props.row.fourthBed != null" class="el-form--inline-icon">
                        <el-icon @click="detailIcon(4, props.row)">
                          <more-filled />
                        </el-icon>
                        <el-icon @click="editIcon(4, props.row)">
                          <edit />
                        </el-icon>
                        <el-popconfirm title="确认删除？" @confirm="deleteStuBed(4, props.row)">
                          <template #reference>
                            <el-icon>
                              <delete />
                            </el-icon>
                          </template>
                        </el-popconfirm>
                      </div>
                    </div>
                  </template>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column label="房间号" prop="dormRoomId" sortable />
          <el-table-column label="状态" width="120px">
            <template #default="scope">
              <el-tag v-if="scope.row.status === '0' || scope.row.status === 0" type="info">锁定</el-tag>
              <el-tag v-else type="success">正常</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="楼栋号" prop="dormBuildId" sortable />
          <el-table-column label="楼层" prop="floorNum" sortable />
          <el-table-column label="最多可住人数" prop="maxCapacity" />
          <el-table-column label="已住人数" prop="currentCapacity" sortable />
          <!--      操作栏-->
          <el-table-column label="操作" width="130px">
            <template #default="scope">
              <el-button icon="Edit" type="primary" @click="handleEdit(scope.row)"></el-button>
              <el-popconfirm title="确认删除？" @confirm="handleDelete(scope.row.dormRoomId)">
                <template #reference>
                  <el-button icon="Delete" type="danger"></el-button>
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <div style="margin: 10px 0">
          <el-pagination v-model:currentPage="currentPage" :page-size="pageSize" :page-sizes="[10, 20]" :total="total"
            layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
          </el-pagination>
        </div>
        <!--      弹窗-->
        <div>
          <el-dialog v-model="dialogVisible" title="操作" width="30%" @close="cancel">
            <el-form ref="form" :model="form" :rules="rules" label-width="120px">
              <el-form-item label="楼栋号" prop="dormBuildId">
                <el-input v-model.number="form.dormBuildId" style="width: 80%"></el-input>
              </el-form-item>
              <el-form-item label="楼层数" prop="floorNum">
                <el-input v-model.number="form.floorNum" style="width: 80%"></el-input>
              </el-form-item>
              <el-form-item label="房间号" prop="dormRoomId">
                <el-input v-model.number="form.dormRoomId" :disabled="disabled" style="width: 80%"></el-input>
              </el-form-item>
              <el-form-item label="最多可住人数" prop="maxCapacity">
                <el-input v-model.number="form.maxCapacity" style="width: 80%"></el-input>
              </el-form-item>
              <el-form-item label="已住人数" prop="currentCapacity">
                <el-input v-model.number="form.currentCapacity" style="width: 80%"></el-input>
              </el-form-item>
              <el-form-item label="是否锁定" prop="currentCapacity">
                <el-radio-group v-model="form.status">
                  <el-radio value="0">是</el-radio>
                  <el-radio value="1">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
            <template #footer>
              <span class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
              </span>
            </template>
          </el-dialog>
          <!-- 床位 弹窗-->
          <el-dialog v-model="bedDialog" title="操作" width="30%" @close="cancel">
            <el-form ref="form" :model="form" :rules="rules" label-width="120px">
              <el-form-item label="楼栋号" prop="dormBuildId">
                <el-input v-model.number="form.dormBuildId" disabled="true" style="width: 80%"></el-input>
              </el-form-item>
              <el-form-item label="楼层数" prop="floorNum">
                <el-input v-model.number="form.floorNum" disabled="true" style="width: 80%"></el-input>
              </el-form-item>
              <el-form-item label="房间号" prop="dormRoomId">
                <el-input v-model.number="form.dormRoomId" disabled="true" style="width: 80%"></el-input>
              </el-form-item>
              <el-form-item v-if="this.bedNum === 1" label="床位(一)" prop="firstBed">
                <!-- <el-input v-model.number="form.firstBed" placeholder="请输入学号" style="width: 80%"></el-input> -->
                <el-select v-model="form.firstBed" filterable remote reserve-keyword placeholder="请输入学员姓名"
                  :remote-method="remoteMethod" :loading="stuLoading" style="width: 80%">
                  <el-option v-for="item in stuOptions" :key="item.username" :label="item.name + '-' + item.username"
                    :value="item.username" />
                </el-select>
              </el-form-item>
              <el-form-item v-if="this.bedNum === 2" label="床位(二)" prop="secondBed">
                <!-- <el-input v-model.number="form.secondBed" placeholder="请输入学号" style="width: 80%"></el-input> -->
                <el-select v-model="form.secondBed" filterable remote reserve-keyword placeholder="请输入学员姓名"
                  :remote-method="remoteMethod" :loading="stuLoading" style="width: 80%">
                  <el-option v-for="item in stuOptions" :key="item.username" :label="item.name + '-' + item.username"
                    :value="item.username" />
                </el-select>
              </el-form-item>
              <el-form-item v-if="this.bedNum === 3" label="床位(三)" prop="thirdBed">
                <!-- <el-input v-model.number="form.thirdBed" placeholder="请输入学号" style="width: 80%"></el-input> -->
                <el-select v-model="form.thirdBed" filterable remote reserve-keyword placeholder="请输入学员姓名"
                  :remote-method="remoteMethod" :loading="stuLoading" style="width: 80%">
                  <el-option v-for="item in stuOptions" :key="item.username" :label="item.name + '-' + item.username"
                    :value="item.username" />
                </el-select>
              </el-form-item>
              <el-form-item v-if="this.bedNum === 4" label="床位(四)" prop="fourthBed">
                <!-- <el-input v-model.number="form.fourthBed" placeholder="请输入学号" style="width: 80%"></el-input> -->
                <el-select v-model="form.fourthBed" filterable remote reserve-keyword placeholder="请输入学员姓名"
                  :remote-method="remoteMethod" :loading="stuLoading" style="width: 80%">
                  <el-option v-for="item in stuOptions" :key="item.username" :label="item.name + '-' + item.username"
                    :value="item.username" />
                </el-select>
              </el-form-item>
            </el-form>
            <template #footer>
              <span class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button v-if="this.judge === false" type="primary" @click="addStuBed">确 定</el-button>
                <el-button v-if="this.judge === true" type="primary" @click="editStuBed">确 定</el-button>
              </span>
            </template>
          </el-dialog>
          <!-- 学员信息弹窗-->
          <el-dialog v-model="stuInfoDialog" title="学员信息" width="20%" @close="cancel">
            <el-form ref="form" :model="form" label-width="120px">
              <el-form-item label="学号：" prop="username">
                <template #default="scope">
                  <span>{{ form.username }}</span>
                </template>
              </el-form-item>
              <el-form-item label="姓名：" prop="name">
                <template #default="scope">
                  <span>{{ form.name }}</span>
                </template>
              </el-form-item>
              <el-form-item label="年龄：" prop="age">
                <template #default="scope">
                  <span>{{ form.age }}</span>
                </template>
              </el-form-item>
              <el-form-item label="性别：" prop="gender">
                <template #default="scope">
                  <span>{{ form.gender }}</span>
                </template>
              </el-form-item>
              <el-form-item label="手机号：" prop="phoneNum">
                <template #default="scope">
                  <span>{{ form.phoneNum }}</span>
                </template>
              </el-form-item>
              <el-form-item label="邮箱地址：" prop="email">
                <template #default="scope">
                  <span>{{ form.email }}</span>
                </template>
              </el-form-item>
            </el-form>
          </el-dialog>
          <!-- 导入房间弹窗-->
          <el-dialog v-model="importRoomDialogVisible" title="导入房间信息" width="30%" @close="cancelImportRoom">
            <div style="margin-bottom: 15px;">
              <el-button type="success" icon="Download" @click="downloadRoomTemplate">下载导入模板</el-button>
            </div>
            <el-upload
              ref="uploadRoomRef"
              action=""
              :auto-upload="false"
              :on-change="handleRoomFileChange"
              :limit="1"
              accept=".xlsx,.xls"
            >
              <el-button type="primary">选择Excel文件</el-button>
              <template #tip>
                <div style="margin-top: 10px; color: #909399;">支持 .xlsx 或 .xls 格式，必须包含列：房间编号、楼栋编号、楼层、最大容量</div>
              </template>
            </el-upload>
            <template #footer>
              <span class="dialog-footer">
                <el-button @click="cancelImportRoom">取 消</el-button>
                <el-button type="primary" @click="confirmImportRoom">确 定</el-button>
              </span>
            </template>
          </el-dialog>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script src="@/assets/js/RoomInfo.js"></script>
<style scoped>
@import '../assets/css/RoomInfo.css';
</style>